<style>

    .login-page-content .input-style-2 input {
        height: 45px !important;
        font-size: 20px !important;
        padding-right: 40px !important
    }
    .login-page-content button {
        height: 45px !important;
        height: 45px !important;
    }
	.login-page-content .input-style-2 span {
		font-size: 15px !important;
		top: 10px !important;
		padding-right: 20px !important
	}

		.login-page-content .input-style-2 span.input-style-1-active {
			font-size: 13px !important;
		}

	.login-page-content .input-style-2.has-icon .input-style-1-active {
		color: #4a89dc !important
	}

	.login-page-content .input-style-2.has-icon .input-icon {
		margin-top: 11px !important;
		font-size: 22px !important
	}

	.login-page-content .card {
		-webkit-transform: translate3d(0, 0, 0);
		background-size: cover;
		border: 0px !important;
		max-height: 150000px;
		background-position: center center !important;
		margin-bottom: 0 !important;
	}

	.login-page-content .logo-Box {
		text-align: center;
		padding: 25px 0;
	}



	.login-page-content .bg-theme {
		background-color: #FFF !important;
	}
	.theme-dark .login-page-content .bg-theme {
		background-color: #0f1117 !important;
	}

</style>
<template>
	<div id="page">
		<div class="page-content py-0 login-page-content">
			<div class="card" id="login-card" style="background-image: url(/assets/images/bg10.jpg); ">
				<div class="card-body">
					<div class="logo-Box">
						<img v-if="isKarnegasht==true" class="preload-img rounded-circle" src="/assets/images/karnegasht-logo-02.png" alt="karnegasht-logo" width="130" />
						<img v-if="isKarnegasht==false" class="preload-img rounded-circle" src="/assets/images/taskinoIcon-02.png" alt="taskino-logo" width="130" />
						<p class="font-12 mt-2 color-highlight mb-0">نسخه شماره {{appVersionCode}}</p>
					</div>
					<!--<p class="text-center" v-if="appVersionCode!='4.11.1'">
						<i class="fa fa-exclamation-triangle text-danger ml-2"></i>
						کاربرانی که قبلاً نشانی mobile.taskinoapp.com را به صفحه اصلی (Add to Home Screen) اضافه کرده‌اند، 
						<b class="text-danger">لطفاً نشانی جدید mobile.taskinoapp.com را جایگزین کنند. </b>						
						برای دانلود نسخه به‌روزرسانی شده و انجام مراحل لازم، به https://taskinoapp.com/
						مراجعه نمایید.
					</p>-->
					<div class="mt-5">
						<div class="input-style input-style-2 has-icon input-required my-3">
							<i class="input-icon fa fa-user color-blue2-dark"></i>
							<span class="color-highlight">آدرس ایمیل یا شماره تلفن همراه</span>
							<input type="text" v-model="username" @input="v$.username.$touch()" :class="{invalid:v$.username.$error}" id="username" class="text-right ltr" autocomplete="new-password">
							<p class="text-danger" v-if="v$.username.required.$invalid && v$.username.$dirty">لطفا آدرس ایمیل یا شماره تلفن همراه را وارد کنید</p>
						</div>
						<div class="input-style input-style-2 has-icon input-required my-3">
							<i class="input-icon fa fa-lock color-blue2-dark"></i>
							<span class="color-highlight">رمز عبور</span>
							<input type="password" v-model="password" @blur="v$.password.$touch()" :class="{invalid:v$.password.$error}" autocomplete="new-password">
							<p class="text-danger" v-if="v$.password.required.$invalid && v$.password.$dirty">لطفا کلمه عبور را وارد کنید</p>
						</div>

						<button :disabled="v$.$invalid || Loading" class="btn btn-l mb-3 font-14 font-900 shadow-s bg-blue2-dark rounded-sm w-100" @click.prevent="LoginUser">ورود</button>

						<router-link v-if="isMinVersion==true" to="/register" class="btn btn-l mb-3 font-14 font-900 shadow-s bg-magenta1-light rounded-sm w-100">ثبت نام</router-link>

						<router-link to="/ForgotPass" class="btn btn-l font-14 font-900 shadow-s bg-blue1-dark rounded-sm w-100">رمز عبور خود را فراموش کرده اید؟</router-link>

					</div>
				
				</div>
				<div class="card-overlay bg-theme opacity-98"></div>
			</div>
		</div>
		<!-- end of page content-->


		<transition v-if="UserStatuse.length>0 && showModal" name="modal" enter-active-class="animated fadeIn" appear>
			<div class="modal-mask">
				<div class="modal-wrapper">
					<div class="modal-container">
						<div class="modal-body m-0">
							<div class="list-group-div py-2" v-for="item in UserStatuse" :key="item.logId">
								<div class="d-flex align-items-center justify-content-start">
									<i class="fa fa-user color-green1-dark px-3"></i>
									<b>{{item.ipAddress}}</b>
									<b class="line-height-s pr-2">{{item.deviceInfo}}</b>
								</div>
								<button class="mt-3 btn btn-s font-14 font-900 shadow-s bg-red1-dark rounded-sm w-100" @click.prevent="RemoveUserLogin(item)" type="button"><i class="fa fa-sign-in-alt ml-2"></i>خروج کاربر</button>
							</div>
						</div>

					</div>
				</div>
			</div>
		</transition>
		<transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
			<div v-if="Loading" class="w-100 d-flex justify-content-center loadingBox">
				<div class="toast-tiny toast-top bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>لطفا صبر کنید ...</div>
			</div>
		</transition>
	</div>
</template>
<script>
	import useVuelidate from '@vuelidate/core'
	import { required } from '@vuelidate/validators';
    import VueSimpleAlert from "vue3-simple-alert";
	export default {
		setup: () => ({ v$: useVuelidate() }),
		data() {
			return {
				showInBazar: false,
				showModal: true,
				username: "",
				password: "",
				lasDownloadLink: ""
			};
		},
		computed: {
			Loading() {
				return this.$store.getters.GetLoading;
			}
            ,
			UserStatuse() {
                return this.$store.getters.GetUserStatuse;
            }

		},
		mounted() {
			this.loadScriptsLanding();
			this.$store.commit("SetLoading", false);
			this.$http
				.get("Account/GetLasDownloadLink")
				.then((data) => {
					var res = data.data;
					this.lasDownloadLink = res;
				});
			var windowHeight = screen.height;
			var card = document.getElementById("login-card");
			card.style.height = windowHeight + "px";
		},
		methods: {
            RemoveUserLogin(item) {
                this.$http
                    .get("Account/ClearUserStatus?id=" + item.logId)
                    .then((data) => {
                        if (data.data.isSuccess) {
                           this.showModal=false;

                        } else {
                            this.showErrorMessage(data.data.message);
                        }
                    });
            },
			LoginUser() {

				const login = {
					phoneNumber: this.username,
					password: this.password
				};

				this.$store.dispatch("LoginUser", login);
			},
			loadScriptsLanding() {///هرجا به مشکل لود نشدن کاستوم جی اس خوردید این فانگشن رو در سمت متدد اون صفحه بارید و در قسمت کرییت فانگشن رو کال کنید.
				let recaptchaScript = document.createElement("script");
				recaptchaScript.setAttribute("id", "customjsScript")
				recaptchaScript.setAttribute("src", "./assets/scripts/custom.js?");
				var exist = document.getElementById("customjsScript");
				if (exist) {
					exist.remove();
				}

				document.head.appendChild(recaptchaScript);
			},
		},
		created() {
			//this.loadScriptsLanding();
			//         this.$http
			//             .get("Task/GetPayInBazarAllowAnonymous")
			//             .then((data) => {
			//                 var res = data.data;
			//                 this.showInBazar = res.isSuccess;
			//             });
		},
		validations: {
			username: {
				required,
			},
			password: {
				required
			}

		}

	};
</script>


<style>
	.invalid {
		border: 1px solid red !important;
		box-shadow: 0 0 5px red !important;
	}
</style>

